module.exports = __webpack_public_path__ + "static/img/role.2cd34d28.png";